// import { useState, useRef } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   Visibility,
//   VisibilityOff,
//   Close as CloseIcon,
// } from "@mui/icons-material";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
//             "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
//             "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
//           },
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-input": { color: "#ffffff" },
//           "& .MuiIconButton-root": { color: "rgba(255, 255, 255, 0.7)" },
//         },
//       },
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#f5f5f5",
//           color: "#000",
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
//         },
//         list: {
//           "& .MuiMenuItem-root": {
//             "&:hover": {
//               backgroundColor: "rgba(0, 0, 0, 0.06)",
//             },
//             "&.Mui-selected": {
//               backgroundColor: "rgba(0, 188, 212, 0.16)",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 188, 212, 0.24)",
//               },
//             },
//           },
//         },
//       },
//     },
//     MuiDialog: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#1e1e1e",
//           backgroundImage: "none",
//           border: "1px solid rgba(255, 255, 255, 0.2)",
//         },
//       },
//     },
//   },
// });

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();
//   const { register, verifyOtp, resendOtp } = useAuth();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//     aadharNumber: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);

//   // State and ref for the new OTP input
//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const otpInputRefs = useRef([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else if (name === "aadharNumber") {
//       setFormData((prev) => ({
//         ...prev,
//         aadharNumber: value.replace(/\D/g, "").slice(0, 12),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.aadharNumber || formData.aadharNumber.length !== 12)
//       newErrors.aadharNumber = "Aadhar must be 12 digits";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       // phone_number: `+91${formData.phone}`,
//       phone_number: formData.phone,
//     };

//     const result = await register(apiPayload);
//     if (result.success) {
//       setOtpDialogOpen(true);
//     } else {
//       setErrors(
//         result.errors || { general: "Registration failed. Please try again." }
//       );
//     }
//     setIsLoading(false);
//   };

//   const handleOtpChange = (element, index) => {
//     if (isNaN(element.value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);

//     if (element.value && index < otp.length - 1) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpInputRefs.current[index - 1].focus();
//     }
//   };

//   const handleClearOtp = () => {
//     setOtp(new Array(6).fill(""));
//     otpInputRefs.current[0].focus();
//   };

//   const handleVerifyOtp = async () => {
//     const otpCode = otp.join("");
//     if (otpCode.length < 6) {
//       alert("Please enter the complete 6-digit OTP.");
//       return;
//     }
//     const result = await verifyOtp({ username: formData.username, otp: otpCode });
//     if (result.success) {
//       alert("OTP Verified! You can now log in.");
//       setOtpDialogOpen(false);
//       navigate("/gatep/login");
//     } else {
//       alert(result.error);
//       handleClearOtp();
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     const result = await resendOtp({
//       username: formData.username,
//       email: formData.email,
//     });
//     if (result.success) {
//       alert("A new OTP has been sent.");
//       handleClearOtp();
//     } else {
//       alert(result.error);
//     }
//     setResendLoading(false);
//   };

//   const handleCloseOtpDialog = () => {
//     setOtpDialogOpen(false);
//     handleClearOtp();
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflowY: "auto",
//           backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Register1.jpg)`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: { xs: "center", md: "flex-end" },
//           padding: 4,
//         }}
//       >
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 420,
//             width: "100%",
//             marginRight: { md: 8 },
//             maxHeight: "95vh",
//             overflowY: "auto",
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",
//                 mb: 1,
//                 fontSize: "1.8rem",
//               }}
//             >
//               Sign Up Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.8)",
//                 mb: 1,
//                 fontSize: "1rem",
//               }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="email"
//                 label="Email Address"
//                 type="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//               />
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start"></InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 name="role"
//                 label="Role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 error={!!errors.role}
//                 helperText={errors.role}
//               >
//                 {roleOptions.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </TextField>
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="aadharNumber"
//                 label="Aadhar Number"
//                 value={formData.aadharNumber}
//                 onChange={handleChange}
//                 inputProps={{ maxLength: 12 }}
//                 error={!!errors.aadharNumber}
//                 helperText={errors.aadharNumber}
//               />
//             </Box>
//             <TextField
//               fullWidth
//               size="small"
//               name="password"
//               label="Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                   "&:hover": { textDecoration: "underline" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>

//       <Dialog
//         open={otpDialogOpen}
//         onClose={handleCloseOtpDialog}
//         PaperProps={{
//           elevation: 24,
//           sx: {
//             maxWidth: "450px",
//             width: "100%",
//             padding: "25px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             borderRadius: "12px",
//             position: "relative",
//           },
//         }}
//       >
//         <IconButton
//           aria-label="close"
//           onClick={handleCloseOtpDialog}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "text.secondary",
//             "&:hover": {
//               color: "text.primary",
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//           }}
//         >
//           <CloseIcon fontSize="small" />
//         </IconButton>

//         <Box sx={{ mb: 3, textAlign: "center" }}>
//           <Typography
//             variant="h5"
//             component="h1"
//             sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
//           >
//             Account Verification
//           </Typography>
//           <Typography variant="body1" sx={{ color: "text.secondary" }}>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//         </Box>

//         <Stack
//           direction="row"
//           spacing={1.5}
//           sx={{ mb: 3, justifyContent: "center" }}
//         >
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e.target, index)}
//               onKeyDown={(e) => handleOtpKeyDown(e, index)}
//               inputRef={(el) => (otpInputRefs.current[index] = el)}
//               inputProps={{
//                 maxLength: 1,
//                 style: {
//                   textAlign: "center",
//                   fontSize: "1.5rem",
//                   fontFamily: "'Trebuchet MS', sans-serif",
//                 },
//               }}
//               sx={{
//                 width: { xs: "2.5em", sm: "3em" },
//                 height: { xs: "2.5em", sm: "3em" },
//                 "& .MuiOutlinedInput-root": {
//                   height: "100%",
//                   backgroundColor: "rgba(255, 255, 255, 0.08)",
//                   borderRadius: "8px",
//                   "& fieldset": {
//                     borderWidth: "1px",
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "primary.main",
//                   },
//                   "&.Mui-focused": {
//                     transform: "scale(1.05)",
//                     transition: "transform 0.2s ease-in-out",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: "primary.main",
//                     borderWidth: "2px",
//                   },
//                 },
//                 "& .MuiOutlinedInput-input": {
//                   padding: 0,
//                   color: "text.primary",
//                 },
//               }}
//             />
//           ))}
//         </Stack>

//         <Stack direction="column" spacing={2} sx={{ width: "85%" }}>
//           <Button
//             variant="contained"
//             onClick={handleVerifyOtp}
//             size="large"
//             sx={{
//               borderRadius: "8px",
//               fontWeight: 700,
//               textTransform: "none",
//             }}
//           >
//             Verify
//           </Button>
//           <Stack direction="row" spacing={1} justifyContent="center">
//             <Button
//               onClick={handleResendOtp}
//               disabled={resendLoading}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               {resendLoading ? "Sending..." : "Resend OTP"}
//             </Button>
//             <Typography sx={{ color: "text.secondary" }}>|</Typography>
//             <Button
//               onClick={handleClearOtp}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Stack>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;

// import { useState } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
//             "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
//             "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
//           },
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-input": { color: "#ffffff" },
//           "& .MuiIconButton-root": { color: "rgba(255, 255, 255, 0.7)" },
//         },
//       },
//     },
//     // START: Added style for the dropdown menu
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#f5f5f5", // Light background for the dropdown menu
//           color: "#000", // Dark text for readability on the light background
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)", // Professional shadow
//         },
//         list: {
//           "& .MuiMenuItem-root": {
//             // Hover state for menu items
//             "&:hover": {
//               backgroundColor: "rgba(0, 0, 0, 0.06)",
//             },
//             // Selected state for menu items
//             "&.Mui-selected": {
//               backgroundColor: "rgba(0, 188, 212, 0.16)", // Use a shade of your primary color
//               "&:hover": {
//                 backgroundColor: "rgba(0, 188, 212, 0.24)", // Darker shade on hover for selected item
//               },
//             },
//           },
//         },
//       },
//     },
//     // END: Added style for the dropdown menu
//   },
// });

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();
//   const { register, verifyOtp, resendOtp } = useAuth();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//     aadharNumber: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [resendLoading, setResendLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else if (name === "aadharNumber") {
//       setFormData((prev) => ({
//         ...prev,
//         aadharNumber: value.replace(/\D/g, "").slice(0, 12),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.aadharNumber || formData.aadharNumber.length !== 12)
//       newErrors.aadharNumber = "Aadhar must be 12 digits";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: `+91${formData.phone}`,
//     };

//     const result = await register(apiPayload);
//     if (result.success) {
//       setOtpDialogOpen(true);
//     } else {
//       setErrors(
//         result.errors || { general: "Registration failed. Please try again." }
//       );
//     }
//     setIsLoading(false);
//   };

//   const handleVerifyOtp = async () => {
//     const result = await verifyOtp({ username: formData.username, otp });
//     if (result.success) {
//       alert("OTP Verified! You can now log in.");
//       setOtpDialogOpen(false);
//       navigate("/gatep/login");
//     } else {
//       alert(result.error);
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     const result = await resendOtp({
//       username: formData.username,
//       email: formData.email,
//     });
//     if (result.success) {
//       alert("A new OTP has been sent.");
//     } else {
//       alert(result.error);
//     }
//     setResendLoading(false);
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflowY: "auto",
//           backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Register1.jpg)`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: { xs: "center", md: "flex-end" },
//           padding: 4,
//         }}
//       >
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 420,
//             width: "100%",
//             marginRight: { md: 8 },
//             maxHeight: "95vh",
//             overflowY: "auto",
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",
//                 mb: 1,
//                 fontSize: "1.8rem",
//               }}
//             >
//               Sign Up Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.8)",
//                 mb: 1,
//                 fontSize: "1rem",
//               }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="email"
//                 label="Email Address"
//                 type="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//               />
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">+91</InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 name="role"
//                 label="Role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 error={!!errors.role}
//                 helperText={errors.role}
//               >
//                 {roleOptions.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </TextField>
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="aadharNumber"
//                 label="Aadhar Number"
//                 value={formData.aadharNumber}
//                 onChange={handleChange}
//                 inputProps={{ maxLength: 12 }}
//                 error={!!errors.aadharNumber}
//                 helperText={errors.aadharNumber}
//               />
//             </Box>
//             <TextField
//               fullWidth
//               size="small"
//               name="password"
//               label="Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                   "&:hover": { textDecoration: "underline" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>
//       <Dialog open={otpDialogOpen} onClose={() => setOtpDialogOpen(false)}>
//         <DialogTitle>Verify Your Account</DialogTitle>
//         <DialogContent>
//           <Typography>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Enter OTP"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value)}
//             inputProps={{ maxLength: 6 }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleResendOtp} disabled={resendLoading}>
//             {resendLoading ? "Sending..." : "Resend OTP"}
//           </Button>
//           <Button onClick={handleVerifyOtp} variant="contained">
//             Verify
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;

// import { useState } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
//             "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
//             "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
//           },
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-input": { color: "#ffffff" },
//           "& .MuiIconButton-root": { color: "rgba(255, 255, 255, 0.7)" },
//         },
//       },
//     },
//   },
// });

// const roleOptions = ["TALENT", "ADMIN", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();
//   const { register, verifyOtp, resendOtp } = useAuth();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//     aadharNumber: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [resendLoading, setResendLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else if (name === "aadharNumber") {
//       setFormData((prev) => ({
//         ...prev,
//         aadharNumber: value.replace(/\D/g, "").slice(0, 12),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.aadharNumber || formData.aadharNumber.length !== 12)
//       newErrors.aadharNumber = "Aadhar must be 12 digits";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: `+91${formData.phone}`,
//     };

//     const result = await register(apiPayload);
//     if (result.success) {
//       setOtpDialogOpen(true);
//     } else {
//       setErrors(
//         result.errors || { general: "Registration failed. Please try again." }
//       );
//     }
//     setIsLoading(false);
//   };

//   const handleVerifyOtp = async () => {
//     const result = await verifyOtp({ username: formData.username, otp });
//     if (result.success) {
//       alert("OTP Verified! You can now log in.");
//       setOtpDialogOpen(false);
//       navigate("/gatep/login");
//     } else {
//       alert(result.error);
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     const result = await resendOtp({
//       username: formData.username,
//       email: formData.email,
//     });
//     if (result.success) {
//       alert("A new OTP has been sent.");
//     } else {
//       alert(result.error);
//     }
//     setResendLoading(false);
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflowY: "auto",
//           backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Registration.jpg)`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: { xs: "center", md: "flex-end" },
//           padding: 4,
//         }}
//       >
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 420,
//             width: "100%",
//             marginRight: { md: 8 },
//             maxHeight: "95vh",
//             overflowY: "auto",
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{ color: "white", fontWeight: "bold", mb: 1 }}
//             >
//               Register Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mb: 1 }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="email"
//                 label="Email Address"
//                 type="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//               />
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">+91</InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 name="role"
//                 label="Role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 error={!!errors.role}
//                 helperText={errors.role}
//               >
//                 {roleOptions.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </TextField>
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="aadharNumber"
//                 label="Aadhar Number"
//                 value={formData.aadharNumber}
//                 onChange={handleChange}
//                 inputProps={{ maxLength: 12 }}
//                 error={!!errors.aadharNumber}
//                 helperText={errors.aadharNumber}
//               />
//             </Box>
//             <TextField
//               fullWidth
//               size="small"
//               name="password"
//               label="Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                   "&:hover": { textDecoration: "underline" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>
//       <Dialog open={otpDialogOpen} onClose={() => setOtpDialogOpen(false)}>
//         <DialogTitle>Verify Your Account</DialogTitle>
//         <DialogContent>
//           <Typography>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Enter OTP"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value)}
//             inputProps={{ maxLength: 6 }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleResendOtp} disabled={resendLoading}>
//             {resendLoading ? "Sending..." : "Resend OTP"}
//           </Button>
//           <Button onClick={handleVerifyOtp} variant="contained">
//             Verify
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;

// import { useState, useRef } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   Visibility,
//   VisibilityOff,
//   Close as CloseIcon,
// } from "@mui/icons-material";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
//             "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
//             "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
//           },
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-input": { color: "#ffffff" },
//           "& .MuiIconButton-root": { color: "rgba(255, 255, 255, 0.7)" },
//         },
//       },
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#f5f5f5",
//           color: "#000",
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
//         },
//         list: {
//           "& .MuiMenuItem-root": {
//             "&:hover": {
//               backgroundColor: "rgba(0, 0, 0, 0.06)",
//             },
//             "&.Mui-selected": {
//               backgroundColor: "rgba(0, 188, 212, 0.16)",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 188, 212, 0.24)",
//               },
//             },
//           },
//         },
//       },
//     },
//     MuiDialog: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#1e1e1e",
//           backgroundImage: "none",
//           border: "1px solid rgba(255, 255, 255, 0.2)",
//         },
//       },
//     },
//   },
// });

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//     aadharNumber: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [registrationToken, setRegistrationToken] = useState(null);

//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const otpInputRefs = useRef([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else if (name === "aadharNumber") {
//       setFormData((prev) => ({
//         ...prev,
//         aadharNumber: value.replace(/\D/g, "").slice(0, 12),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.aadharNumber || formData.aadharNumber.length !== 12)
//       newErrors.aadharNumber = "Aadhar must be 12 digits";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: formData.phone,
//     };

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/register/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(apiPayload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok && result.registration_token) {
//         setRegistrationToken(result.registration_token);
//         setOtpDialogOpen(true);
//       } else {
//         setErrors(
//           result.errors || {
//             general: result.message || "Registration failed. Please try again.",
//           }
//         );
//       }
//     } catch (error) {
//       setErrors({ general: "An error occurred. Please try again later." });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOtpChange = (element, index) => {
//     if (isNaN(element.value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);

//     if (element.value && index < otp.length - 1) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpInputRefs.current[index - 1].focus();
//     }
//   };

//   const handleClearOtp = () => {
//     setOtp(new Array(6).fill(""));
//     otpInputRefs.current[0].focus();
//   };

//   const handleVerifyOtp = async () => {
//     const otpCode = otp.join("");
//     if (otpCode.length < 6) {
//       alert("Please enter the complete 6-digit OTP.");
//       return;
//     }
//     if (!registrationToken) {
//       alert("Registration token not found. Please try registering again.");
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/verify/registration/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             otp: otpCode,
//             registration_token: registrationToken,
//           }),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         alert("OTP Verified! You can now log in.");
//         setOtpDialogOpen(false);
//         navigate("/gatep/login");
//       } else {
//         alert(result.error || "Invalid OTP or verification failed.");
//         handleClearOtp();
//       }
//     } catch (error) {
//       alert("An error occurred during verification.");
//       handleClearOtp();
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     if (!registrationToken) {
//       alert("Registration token not found. Cannot resend OTP.");
//       setResendLoading(false);
//       return;
//     }
//     try {
//       const response = await fetch("/resend-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ registration_token: registrationToken }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         alert("A new OTP has been sent.");
//         handleClearOtp();
//       } else {
//         alert(data.error || "Failed to resend OTP.");
//       }
//     } catch (error) {
//       alert("An error occurred while resending OTP.");
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseOtpDialog = () => {
//     setOtpDialogOpen(false);
//     handleClearOtp();
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflowY: "auto",
//           backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Register1.jpg)`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: { xs: "center", md: "flex-end" },
//           padding: 4,
//         }}
//       >
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 420,
//             width: "100%",
//             marginRight: { md: 8 },
//             maxHeight: "95vh",
//             overflowY: "auto",
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",
//                 mb: 1,
//                 fontSize: "1.8rem",
//               }}
//             >
//               Sign Up Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.8)",
//                 mb: 1,
//                 fontSize: "1rem",
//               }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="email"
//                 label="Email Address"
//                 type="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//               />
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start"></InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 name="role"
//                 label="Role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 error={!!errors.role}
//                 helperText={errors.role}
//               >
//                 {roleOptions.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </TextField>
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="aadharNumber"
//                 label="Aadhar Number"
//                 value={formData.aadharNumber}
//                 onChange={handleChange}
//                 inputProps={{ maxLength: 12 }}
//                 error={!!errors.aadharNumber}
//                 helperText={errors.aadharNumber}
//               />
//             </Box>
//             <TextField
//               fullWidth
//               size="small"
//               name="password"
//               label="Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                   "&:hover": { textDecoration: "underline" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>

//       <Dialog
//         open={otpDialogOpen}
//         onClose={handleCloseOtpDialog}
//         PaperProps={{
//           elevation: 24,
//           sx: {
//             maxWidth: "450px",
//             width: "100%",
//             padding: "25px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             borderRadius: "12px",
//             position: "relative",
//           },
//         }}
//       >
//         <IconButton
//           aria-label="close"
//           onClick={handleCloseOtpDialog}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "text.secondary",
//             "&:hover": {
//               color: "text.primary",
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//           }}
//         >
//           <CloseIcon fontSize="small" />
//         </IconButton>

//         <Box sx={{ mb: 3, textAlign: "center" }}>
//           <Typography
//             variant="h5"
//             component="h1"
//             sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
//           >
//             Account Verification
//           </Typography>
//           <Typography variant="body1" sx={{ color: "text.secondary" }}>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//         </Box>

//         <Stack
//           direction="row"
//           spacing={1.5}
//           sx={{ mb: 3, justifyContent: "center" }}
//         >
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e.target, index)}
//               onKeyDown={(e) => handleOtpKeyDown(e, index)}
//               inputRef={(el) => (otpInputRefs.current[index] = el)}
//               inputProps={{
//                 maxLength: 1,
//                 style: {
//                   textAlign: "center",
//                   fontSize: "1.5rem",
//                   fontFamily: "'Trebuchet MS', sans-serif",
//                 },
//               }}
//               sx={{
//                 width: { xs: "2.5em", sm: "3em" },
//                 height: { xs: "2.5em", sm: "3em" },
//                 "& .MuiOutlinedInput-root": {
//                   height: "100%",
//                   backgroundColor: "rgba(255, 255, 255, 0.08)",
//                   borderRadius: "8px",
//                   "& fieldset": {
//                     borderWidth: "1px",
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "primary.main",
//                   },
//                   "&.Mui-focused": {
//                     transform: "scale(1.05)",
//                     transition: "transform 0.2s ease-in-out",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: "primary.main",
//                     borderWidth: "2px",
//                   },
//                 },
//                 "& .MuiOutlinedInput-input": {
//                   padding: 0,
//                   color: "text.primary",
//                 },
//               }}
//             />
//           ))}
//         </Stack>

//         <Stack direction="column" spacing={2} sx={{ width: "85%" }}>
//           <Button
//             variant="contained"
//             onClick={handleVerifyOtp}
//             size="large"
//             sx={{
//               borderRadius: "8px",
//               fontWeight: 700,
//               textTransform: "none",
//             }}
//           >
//             Verify
//           </Button>
//           <Stack direction="row" spacing={1} justifyContent="center">
//             <Button
//               onClick={handleResendOtp}
//               disabled={resendLoading}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               {resendLoading ? "Sending..." : "Resend OTP"}
//             </Button>
//             <Typography sx={{ color: "text.secondary" }}>|</Typography>
//             <Button
//               onClick={handleClearOtp}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Stack>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;






// import { useState, useRef } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   Visibility,
//   VisibilityOff,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import Swal from "sweetalert2";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
//             "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
//             "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
//           },
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-input": { color: "#ffffff" },
//           "& .MuiIconButton-root": { color: "rgba(255, 255, 255, 0.7)" },
//         },
//       },
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#f5f5f5",
//           color: "#000",
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
//         },
//         list: {
//           "& .MuiMenuItem-root": {
//             "&:hover": {
//               backgroundColor: "rgba(0, 0, 0, 0.06)",
//             },
//             "&.Mui-selected": {
//               backgroundColor: "rgba(0, 188, 212, 0.16)",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 188, 212, 0.24)",
//               },
//             },
//           },
//         },
//       },
//     },
//     MuiDialog: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#1e1e1e",
//           backgroundImage: "none",
//           border: "1px solid rgba(255, 255, 255, 0.2)",
//         },
//       },
//     },
//   },
// });

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [registrationToken, setRegistrationToken] = useState(null);

//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const otpInputRefs = useRef([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: formData.phone,
//     };

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/register/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(apiPayload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok && result.registration_token) {
//         setRegistrationToken(result.registration_token);
//         setOtpDialogOpen(true);
//       } else {
//         setErrors(
//           result.errors || {
//             general: result.message || "Registration failed. Please try again.",
//           }
//         );
//       }
//     } catch (error) {
//       setErrors({ general: "An error occurred. Please try again later." });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOtpChange = (element, index) => {
//     if (isNaN(element.value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);

//     if (element.value && index < otp.length - 1) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpInputRefs.current[index - 1].focus();
//     }
//   };

//   const handleClearOtp = () => {
//     setOtp(new Array(6).fill(""));
//     otpInputRefs.current[0].focus();
//   };

//   const handleVerifyOtp = async () => {
//     const otpCode = otp.join("");
//     if (otpCode.length < 6) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please enter the complete 6-digit OTP.",
//       });
//       return;
//     }
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Please try registering again.",
//       });
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/verify/registration/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             otp: otpCode,
//             registration_token: registrationToken,
//           }),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "OTP Verified! You can now log in.",
//         });
//         setOtpDialogOpen(false);
//         navigate("/gatep/login");
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.error || "Invalid OTP or verification failed.",
//         });
//         handleClearOtp();
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred during verification.",
//       });
//       handleClearOtp();
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Cannot resend OTP.",
//       });
//       setResendLoading(false);
//       return;
//     }
//     try {
//       const response = await fetch("/resend-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ registration_token: registrationToken }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "A new OTP has been sent.",
//         });
//         handleClearOtp();
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: data.error || "Failed to resend OTP.",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred while resending OTP.",
//       });
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseOtpDialog = () => {
//     setOtpDialogOpen(false);
//     handleClearOtp();
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflowY: "auto",
//           backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Register1.jpg)`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: { xs: "center", md: "flex-end" },
//           padding: 4,
//         }}
//       >
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 500,
//             width: "100%",
//             marginRight: { md: 8 },
//             maxHeight: "100vh",
//             overflowY: "auto",
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",

//                 fontSize: "1.8rem",
//               }}
//             >
//               Register Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.8)",
//                 mb: 1,
//                 fontSize: "1rem",
//               }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="email"
//                 label="Email Address"
//                 type="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//               />
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start"></InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//             <TextField
//               select
//               size="small"
//               fullWidth
//               name="role"
//               label="Role"
//               value={formData.role}
//               onChange={handleChange}
//               error={!!errors.role}
//               helperText={errors.role}
//             >
//               {roleOptions.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </TextField>
//             <TextField
//               fullWidth
//               size="small"
//               name="password"
//               label="Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                   "&:hover": { textDecoration: "underline" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>

//       <Dialog
//         open={otpDialogOpen}
//         onClose={handleCloseOtpDialog}
//         PaperProps={{
//           elevation: 24,
//           sx: {
//             maxWidth: "450px",
//             width: "100%",
//             padding: "25px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             borderRadius: "12px",
//             position: "relative",
//           },
//         }}
//       >
//         <IconButton
//           aria-label="close"
//           onClick={handleCloseOtpDialog}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "text.secondary",
//             "&:hover": {
//               color: "text.primary",
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//           }}
//         >
//           <CloseIcon fontSize="small" />
//         </IconButton>

//         <Box sx={{ mb: 3, textAlign: "center" }}>
//           <Typography
//             variant="h5"
//             component="h1"
//             sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
//           >
//             Account Verification
//           </Typography>
//           <Typography variant="body1" sx={{ color: "text.secondary" }}>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//         </Box>

//         <Stack
//           direction="row"
//           spacing={1.5}
//           sx={{ mb: 3, justifyContent: "center" }}
//         >
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e.target, index)}
//               onKeyDown={(e) => handleOtpKeyDown(e, index)}
//               inputRef={(el) => (otpInputRefs.current[index] = el)}
//               inputProps={{
//                 maxLength: 1,
//                 style: {
//                   textAlign: "center",
//                   fontSize: "1.5rem",
//                   fontFamily: "'Trebuchet MS', sans-serif",
//                 },
//               }}
//               sx={{
//                 width: { xs: "2.5em", sm: "3em" },
//                 height: { xs: "2.5em", sm: "3em" },
//                 "& .MuiOutlinedInput-root": {
//                   height: "100%",
//                   backgroundColor: "rgba(255, 255, 255, 0.08)",
//                   borderRadius: "8px",
//                   "& fieldset": {
//                     borderWidth: "1px",
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "primary.main",
//                   },
//                   "&.Mui-focused": {
//                     transform: "scale(1.05)",
//                     transition: "transform 0.2s ease-in-out",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: "primary.main",
//                     borderWidth: "2px",
//                   },
//                 },
//                 "& .MuiOutlinedInput-input": {
//                   padding: 0,
//                   color: "text.primary",
//                 },
//               }}
//             />
//           ))}
//         </Stack>

//         <Stack direction="column" spacing={2} sx={{ width: "85%" }}>
//           <Button
//             variant="contained"
//             onClick={handleVerifyOtp}
//             size="large"
//             sx={{
//               borderRadius: "8px",
//               fontWeight: 700,
//               textTransform: "none",
//             }}
//           >
//             Verify
//           </Button>
//           <Stack direction="row" spacing={1} justifyContent="center">
//             <Button
//               onClick={handleResendOtp}
//               disabled={resendLoading}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               {resendLoading ? "Sending..." : "Resend OTP"}
//             </Button>
//             <Typography sx={{ color: "text.secondary" }}>|</Typography>
//             <Button
//               onClick={handleClearOtp}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Stack>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;


// import { useState, useRef } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   Visibility,
//   VisibilityOff,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import Swal from "sweetalert2";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiOutlinedInput-root": {
//             "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
//             "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
//             "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
//           },
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-input": { color: "#ffffff" },
//           "& .MuiIconButton-root": { color: "rgba(255, 255, 255, 0.7)" },
//         },
//       },
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#f5f5f5",
//           color: "#000",
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
//         },
//         list: {
//           "& .MuiMenuItem-root": {
//             "&:hover": {
//               backgroundColor: "rgba(0, 0, 0, 0.06)",
//             },
//             "&.Mui-selected": {
//               backgroundColor: "rgba(0, 188, 212, 0.16)",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 188, 212, 0.24)",
//               },
//             },
//           },
//         },
//       },
//     },
//     MuiDialog: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#1e1e1e",
//           backgroundImage: "none",
//           border: "1px solid rgba(255, 255, 255, 0.2)",
//         },
//       },
//     },
//   },
// });

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [registrationToken, setRegistrationToken] = useState(null);

//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const otpInputRefs = useRef([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: formData.phone,
//     };

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/register/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(apiPayload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok && result.registration_token) {
//         setRegistrationToken(result.registration_token);
//         setOtpDialogOpen(true);
//       } else {
//         setErrors(
//           result.errors || {
//             general: result.message || "Registration failed. Please try again.",
//           }
//         );
//       }
//     } catch (error) {
//       setErrors({ general: "An error occurred. Please try again later." });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOtpChange = (element, index) => {
//     if (isNaN(element.value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);

//     if (element.value && index < otp.length - 1) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpInputRefs.current[index - 1].focus();
//     }
//   };

//   const handleClearOtp = () => {
//     setOtp(new Array(6).fill(""));
//     otpInputRefs.current[0].focus();
//   };

//   const handleVerifyOtp = async () => {
//     const otpCode = otp.join("");
//     if (otpCode.length < 6) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please enter the complete 6-digit OTP.",
//       });
//       return;
//     }
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Please try registering again.",
//       });
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/verify/registration/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             otp: otpCode,
//             registration_token: registrationToken,
//           }),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "OTP Verified! You can now log in.",
//         });
//         setOtpDialogOpen(false);
//         navigate("/gatep/login");
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.error || "Invalid OTP or verification failed.",
//         });
//         handleClearOtp();
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred during verification.",
//       });
//       handleClearOtp();
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Cannot resend OTP.",
//       });
//       setResendLoading(false);
//       return;
//     }
//     try {
//       const response = await fetch("/resend-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ registration_token: registrationToken }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "A new OTP has been sent.",
//         });
//         handleClearOtp();
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: data.error || "Failed to resend OTP.",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred while resending OTP.",
//       });
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseOtpDialog = () => {
//     setOtpDialogOpen(false);
//     handleClearOtp();
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflow: "hidden", // Hide scrollbars from the video
//           position: "relative", // Needed for positioning the video
//           display: "flex",
//           alignItems: "center",
//           justifyContent: { xs: "center", md: "flex-end" },
//           padding: 4,
//         }}
//       >
//         <video
//           autoPlay
//           loop
//           muted
//           style={{
//             position: "absolute",
//             width: "100%",
//             left: "50%",
//             top: "50%",
//             height: "100%",
//             objectFit: "cover",
//             transform: "translate(-50%, -50%)",
//             zIndex: -1,
//           }}
//         >
//           <source src={`${process.env.PUBLIC_URL}/assets/Blue.mp4`} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 500,
//             width: "100%",
//             marginRight: { md: 8 },
//             maxHeight: "100vh",
//             overflowY: "auto",
//             zIndex: 1, // Ensure the form is on top of the video
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",

//                 fontSize: "1.8rem",
//               }}
//             >
//               Register Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.8)",
//                 mb: 1,
//                 fontSize: "1rem",
//               }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="email"
//                 label="Email Address"
//                 type="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//               />
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start"></InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//             <TextField
//               select
//               size="small"
//               fullWidth
//               name="role"
//               label="Role"
//               value={formData.role}
//               onChange={handleChange}
//               error={!!errors.role}
//               helperText={errors.role}
//             >
//               {roleOptions.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </TextField>
//             <TextField
//               fullWidth
//               size="small"
//               name="password"
//               label="Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                   "&:hover": { textDecoration: "underline" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>

//       <Dialog
//         open={otpDialogOpen}
//         onClose={handleCloseOtpDialog}
//         PaperProps={{
//           elevation: 24,
//           sx: {
//             maxWidth: "450px",
//             width: "100%",
//             padding: "25px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             borderRadius: "12px",
//             position: "relative",
//           },
//         }}
//       >
//         <IconButton
//           aria-label="close"
//           onClick={handleCloseOtpDialog}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "text.secondary",
//             "&:hover": {
//               color: "text.primary",
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//           }}
//         >
//           <CloseIcon fontSize="small" />
//         </IconButton>

//         <Box sx={{ mb: 3, textAlign: "center" }}>
//           <Typography
//             variant="h5"
//             component="h1"
//             sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
//           >
//             Account Verification
//           </Typography>
//           <Typography variant="body1" sx={{ color: "text.secondary" }}>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//         </Box>

//         <Stack
//           direction="row"
//           spacing={1.5}
//           sx={{ mb: 3, justifyContent: "center" }}
//         >
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e.target, index)}
//               onKeyDown={(e) => handleOtpKeyDown(e, index)}
//               inputRef={(el) => (otpInputRefs.current[index] = el)}
//               inputProps={{
//                 maxLength: 1,
//                 style: {
//                   textAlign: "center",
//                   fontSize: "1.5rem",
//                   fontFamily: "'Trebuchet MS', sans-serif",
//                 },
//               }}
//               sx={{
//                 width: { xs: "2.5em", sm: "3em" },
//                 height: { xs: "2.5em", sm: "3em" },
//                 "& .MuiOutlinedInput-root": {
//                   height: "100%",
//                   backgroundColor: "rgba(255, 255, 255, 0.08)",
//                   borderRadius: "8px",
//                   "& fieldset": {
//                     borderWidth: "1px",
//                     borderColor: "rgba(255, 255, 255, 0.3)",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "primary.main",
//                   },
//                   "&.Mui-focused": {
//                     transform: "scale(1.05)",
//                     transition: "transform 0.2s ease-in-out",
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: "primary.main",
//                     borderWidth: "2px",
//                   },
//                 },
//                 "& .MuiOutlinedInput-input": {
//                   padding: 0,
//                   color: "text.primary",
//                 },
//               }}
//             />
//           ))}
//         </Stack>

//         <Stack direction="column" spacing={2} sx={{ width: "85%" }}>
//           <Button
//             variant="contained"
//             onClick={handleVerifyOtp}
//             size="large"
//             sx={{
//               borderRadius: "8px",
//               fontWeight: 700,
//               textTransform: "none",
//             }}
//           >
//             Verify
//           </Button>
//           <Stack direction="row" spacing={1} justifyContent="center">
//             <Button
//               onClick={handleResendOtp}
//               disabled={resendLoading}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               {resendLoading ? "Sending..." : "Resend OTP"}
//             </Button>
//             <Typography sx={{ color: "text.secondary" }}>|</Typography>
//             <Button
//               onClick={handleClearOtp}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Stack>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;



// import { useState, useRef } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   Visibility,
//   VisibilityOff,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import Swal from "sweetalert2";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-root": {
//             backgroundColor: "rgba(255, 255, 255, 0.08)",
//             borderRadius: "8px",
//             "& fieldset": {
//               borderColor: "rgba(255, 255, 255, 0.3)",
//               borderWidth: "1px",
//             },
//             "&:hover fieldset": {
//               borderColor: "#00bcd4",
//             },
//             "&.Mui-focused fieldset": {
//               borderColor: "#00bcd4",
//               borderWidth: "2px",
//             },
//           },
//           "& .MuiOutlinedInput-input": {
//             color: "#ffffff",
//           },
//           "& .MuiIconButton-root": {
//             color: "rgba(255, 255, 255, 0.7)",
//           },
//         },
//       },
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#f5f5f5",
//           color: "#000",
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
//         },
//         list: {
//           "& .MuiMenuItem-root": {
//             "&:hover": {
//               backgroundColor: "rgba(0, 0, 0, 0.06)",
//             },
//             "&.Mui-selected": {
//               backgroundColor: "rgba(0, 188, 212, 0.16)",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 188, 212, 0.24)",
//               },
//             },
//           },
//         },
//       },
//     },
//     MuiDialog: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#1e1e1e",
//           backgroundImage: "none",
//           border: "1px solid rgba(255, 255, 255, 0.2)",
//         },
//       },
//     },
//   },
// });

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [registrationToken, setRegistrationToken] = useState(null);

//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const otpInputRefs = useRef([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: formData.phone,
//     };

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/register/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(apiPayload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok && result.registration_token) {
//         setRegistrationToken(result.registration_token);
//         setOtpDialogOpen(true);
//       } else {
//         setErrors(
//           result.errors || {
//             general: result.message || "Registration failed. Please try again.",
//           }
//         );
//       }
//     } catch (error) {
//       setErrors({ general: "An error occurred. Please try again later." });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOtpChange = (element, index) => {
//     if (isNaN(element.value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);

//     if (element.value && index < otp.length - 1) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpInputRefs.current[index - 1].focus();
//     }
//   };

//   const handleClearOtp = () => {
//     setOtp(new Array(6).fill(""));
//     otpInputRefs.current[0].focus();
//   };

//   const handleVerifyOtp = async () => {
//     const otpCode = otp.join("");
//     if (otpCode.length < 6) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please enter the complete 6-digit OTP.",
//       });
//       return;
//     }
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Please try registering again.",
//       });
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/verify/registration/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             otp: otpCode,
//             registration_token: registrationToken,
//           }),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "OTP Verified! You can now log in.",
//         });
//         setOtpDialogOpen(false);
//         navigate("/gatep/login");
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.error || "Invalid OTP or verification failed.",
//         });
//         handleClearOtp();
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred during verification.",
//       });
//       handleClearOtp();
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Cannot resend OTP.",
//       });
//       setResendLoading(false);
//       return;
//     }
//     try {
//       const response = await fetch("/resend-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ registration_token: registrationToken }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "A new OTP has been sent.",
//         });
//         handleClearOtp();
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: data.error || "Failed to resend OTP.",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred while resending OTP.",
//       });
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseOtpDialog = () => {
//     setOtpDialogOpen(false);
//     handleClearOtp();
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflow: "hidden",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: { xs: "center", md: "flex-end" },
//           padding: 4,
//         }}
//       >
//         <video
//           autoPlay
//           loop
//           muted
//           style={{
//             position: "absolute",
//             width: "100%",
//             left: "50%",
//             top: "50%",
//             height: "100%",
//             objectFit: "cover",
//             transform: "translate(-50%, -50%)",
//             zIndex: -1,
//           }}
//         >
//           <source
//             src={`${process.env.PUBLIC_URL}/assets/Blue.mp4`}
//             type="video/mp4"
//           />
//           Your browser does not support the video tag.
//         </video>
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 500,
//             width: "100%",
//             marginRight: { md: 8 },
//             maxHeight: "100vh",
//             overflowY: "auto",
//             zIndex: 1,
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",
//                 fontSize: "1.8rem",
//               }}
//             >
//               Register Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.8)",
//                 mb: 1,
//                 fontSize: "1rem",
//               }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="email"
//                 label="Email Address"
//                 type="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//               />
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start"></InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//             <TextField
//               select
//               size="small"
//               fullWidth
//               name="role"
//               label="Role"
//               value={formData.role}
//               onChange={handleChange}
//               error={!!errors.role}
//               helperText={errors.role}
//             >
//               {roleOptions.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </TextField>
//             <TextField
//               fullWidth
//               size="small"
//               name="password"
//               label="Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "none",
//                   fontWeight: "bold",
//                   "&:hover": { textDecoration: "underline" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>

//       <Dialog
//         open={otpDialogOpen}
//         onClose={handleCloseOtpDialog}
//         PaperProps={{
//           elevation: 24,
//           sx: {
//             maxWidth: "450px",
//             width: "100%",
//             padding: "25px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             borderRadius: "12px",
//             position: "relative",
//           },
//         }}
//       >
//         <IconButton
//           aria-label="close"
//           onClick={handleCloseOtpDialog}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "text.secondary",
//             "&:hover": {
//               color: "text.primary",
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//           }}
//         >
//           <CloseIcon fontSize="small" />
//         </IconButton>

//         <Box sx={{ mb: 3, textAlign: "center" }}>
//           <Typography
//             variant="h5"
//             component="h1"
//             sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
//           >
//             Account Verification
//           </Typography>
//           <Typography variant="body1" sx={{ color: "text.secondary" }}>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//         </Box>

//         <Stack
//           direction="row"
//           spacing={1.5}
//           sx={{ mb: 3, justifyContent: "center" }}
//         >
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e.target, index)}
//               onKeyDown={(e) => handleOtpKeyDown(e, index)}
//               inputRef={(el) => (otpInputRefs.current[index] = el)}
//               inputProps={{
//                 maxLength: 1,
//                 style: {
//                   textAlign: "center",
//                   fontSize: "1.5rem",
//                   fontFamily: "'Trebuchet MS', sans-serif",
//                 },
//               }}
//               sx={{
//                 width: { xs: "2.5em", sm: "3em" },
//                 height: { xs: "2.5em", sm: "3em" },
//                 "& .MuiOutlinedInput-root": {
//                   height: "100%",
//                   "&.Mui-focused": {
//                     transform: "scale(1.05)",
//                     transition: "transform 0.2s ease-in-out",
//                   },
//                 },
//                 "& .MuiOutlinedInput-input": {
//                   padding: 0,
//                 },
//               }}
//             />
//           ))}
//         </Stack>

//         <Stack direction="column" spacing={2} sx={{ width: "85%" }}>
//           <Button
//             variant="contained"
//             onClick={handleVerifyOtp}
//             size="large"
//             sx={{
//               borderRadius: "8px",
//               fontWeight: 700,
//               textTransform: "none",
//             }}
//           >
//             Verify
//           </Button>
//           <Stack direction="row" spacing={1} justifyContent="center">
//             <Button
//               onClick={handleResendOtp}
//               disabled={resendLoading}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               {resendLoading ? "Sending..." : "Resend OTP"}
//             </Button>
//             <Typography sx={{ color: "text.secondary" }}>|</Typography>
//             <Button
//               onClick={handleClearOtp}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Stack>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;




// import { useState, useRef } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   Visibility,
//   VisibilityOff,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import Swal from "sweetalert2";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-root": {
//             backgroundColor: "rgba(255, 255, 255, 0.08)",
//             borderRadius: "8px",
//             "& fieldset": {
//               borderColor: "rgba(255, 255, 255, 0.3)",
//               borderWidth: "1px",
//             },
//             "&:hover fieldset": {
//               borderColor: "#00bcd4",
//             },
//             "&.Mui-focused fieldset": {
//               borderColor: "#00bcd4",
//               borderWidth: "2px",
//             },
//           },
//           "& .MuiOutlinedInput-input": {
//             color: "#ffffff",
//           },
//           "& .MuiIconButton-root": {
//             color: "rgba(255, 255, 255, 0.7)",
//           },
//         },
//       },
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "rgba(30, 30, 30, 0.85)",
//           backdropFilter: "blur(5px)",
//           color: "#ffffff",
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
//         },
//         list: {
//           "& .MuiMenuItem-root": {
//             "&:hover": {
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//             "&.Mui-selected": {
//               backgroundColor: "rgba(0, 188, 212, 0.16)",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 188, 212, 0.24)",
//               },
//             },
//           },
//         },
//       },
//     },
//     MuiDialog: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#1e1e1e",
//           backgroundImage: "none",
//           border: "1px solid rgba(255, 255, 255, 0.2)",
//         },
//       },
//     },
//   },
// });

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [registrationToken, setRegistrationToken] = useState(null);

//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const otpInputRefs = useRef([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: formData.phone,
//     };

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/register/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(apiPayload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok && result.registration_token) {
//         setRegistrationToken(result.registration_token);
//         setOtpDialogOpen(true);
//       } else {
//         setErrors(
//           result.errors || {
//             general: result.message || "Registration failed. Please try again.",
//           }
//         );
//       }
//     } catch (error) {
//       setErrors({ general: "An error occurred. Please try again later." });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOtpChange = (element, index) => {
//     if (isNaN(element.value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);

//     if (element.value && index < otp.length - 1) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpInputRefs.current[index - 1].focus();
//     }
//   };

//   const handleClearOtp = () => {
//     setOtp(new Array(6).fill(""));
//     otpInputRefs.current[0].focus();
//   };

//   const handleVerifyOtp = async () => {
//     const otpCode = otp.join("");
//     if (otpCode.length < 6) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please enter the complete 6-digit OTP.",
//       });
//       return;
//     }
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Please try registering again.",
//       });
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/verify/registration/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             otp: otpCode,
//             registration_token: registrationToken,
//           }),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "OTP Verified! You can now log in.",
//         });
//         setOtpDialogOpen(false);
//         navigate("/gatep/login");
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.error || "Invalid OTP or verification failed.",
//         });
//         handleClearOtp();
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred during verification.",
//       });
//       handleClearOtp();
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Cannot resend OTP.",
//       });
//       setResendLoading(false);
//       return;
//     }
//     try {
//       const response = await fetch("/resend-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ registration_token: registrationToken }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "A new OTP has been sent.",
//         });
//         handleClearOtp();
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: data.error || "Failed to resend OTP.",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred while resending OTP.",
//       });
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseOtpDialog = () => {
//     setOtpDialogOpen(false);
//     handleClearOtp();
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflow: "hidden",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           padding: 4,
//         }}
//       >
//         <video
//           autoPlay
//           loop
//           muted
//           style={{
//             position: "absolute",
//             width: "100%",
//             left: "50%",
//             top: "50%",
//             height: "100%",
//             objectFit: "cover",
//             transform: "translate(-50%, -50%)",
//             zIndex: -1,
//           }}
//         >
//           <source
//             src={`${process.env.PUBLIC_URL}/assets/Blue.mp4`}
//             type="video/mp4"
//           />
//           Your browser does not support the video tag.
//         </video>
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 500,
//             width: "100%",
//             maxHeight: "100vh",
//             overflowY: "auto",
//             zIndex: 1,
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",
//                 fontSize: "1.8rem",
//               }}
//             >
//               Register Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.8)",
//                 mb: 1,
//                 fontSize: "1rem",
//               }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//               autoComplete="off"
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="email"
//               label="Email "
//               type="email"
//               value={formData.email}
//               onChange={handleChange}
//               error={!!errors.email}
//               helperText={errors.email}
//               autoComplete="off"
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 autoComplete="off"
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start"></InputAdornment>
//                   ),
//                 }}
//               />
//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 name="role"
//                 label="Role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 error={!!errors.role}
//                 helperText={errors.role}
//               >
//                 {roleOptions.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </Box>
//             <TextField
//               fullWidth
//               size="small"
//               name=" password"
//               label="Create Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               autoComplete="new-password"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               autoComplete="new-password"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "underline",
//                   fontWeight: "bold",
//                   "&:hover": { color: "#00bcd4" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>

//       <Dialog
//         open={otpDialogOpen}
//         onClose={handleCloseOtpDialog}
//         PaperProps={{
//           elevation: 24,
//           sx: {
//             maxWidth: "450px",
//             width: "100%",
//             padding: "25px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             borderRadius: "12px",
//             position: "relative",
//           },
//         }}
//       >
//         <IconButton
//           aria-label="close"
//           onClick={handleCloseOtpDialog}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "text.secondary",
//             "&:hover": {
//               color: "text.primary",
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//           }}
//         >
//           <CloseIcon fontSize="small" />
//         </IconButton>

//         <Box sx={{ mb: 3, textAlign: "center" }}>
//           <Typography
//             variant="h5"
//             component="h1"
//             sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
//           >
//             Account Verification
//           </Typography>
//           <Typography variant="body1" sx={{ color: "text.secondary" }}>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//         </Box>

//         <Stack
//           direction="row"
//           spacing={1.5}
//           sx={{ mb: 3, justifyContent: "center" }}
//         >
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e.target, index)}
//               onKeyDown={(e) => handleOtpKeyDown(e, index)}
//               inputRef={(el) => (otpInputRefs.current[index] = el)}
//               inputProps={{
//                 maxLength: 1,
//                 style: {
//                   textAlign: "center",
//                   fontSize: "1.5rem",
//                   fontFamily: "'Trebuchet MS', sans-serif",
//                 },
//               }}
//               sx={{
//                 width: { xs: "2.5em", sm: "3em" },
//                 height: { xs: "2.5em", sm: "3em" },
//                 "& .MuiOutlinedInput-root": {
//                   height: "100%",
//                   "&.Mui-focused": {
//                     transform: "scale(1.05)",
//                     transition: "transform 0.2s ease-in-out",
//                   },
//                 },
//                 "& .MuiOutlinedInput-input": {
//                   padding: 0,
//                 },
//               }}
//             />
//           ))}
//         </Stack>

//         <Stack direction="column" spacing={2} sx={{ width: "85%" }}>
//           <Button
//             variant="contained"
//             onClick={handleVerifyOtp}
//             size="large"
//             sx={{
//               borderRadius: "8px",
//               fontWeight: 700,
//               textTransform: "none",
//             }}
//           >
//             Verify
//           </Button>
//           <Stack direction="row" spacing={1} justifyContent="center">
//             <Button
//               onClick={handleResendOtp}
//               disabled={resendLoading}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               {resendLoading ? "Sending..." : "Resend OTP"}
//             </Button>
//             <Typography sx={{ color: "text.secondary" }}>|</Typography>
//             <Button
//               onClick={handleClearOtp}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Stack>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;






// import { useState, useRef } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   Visibility,
//   VisibilityOff,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import Swal from "sweetalert2";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00bcd4" },
//     background: { default: "#0a0a0a", paper: "rgba(255, 255, 255, 0.1)" },
//     text: { primary: "#ffffff", secondary: "#b0b0b0" },
//   },
//   components: {
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#00bcd4" },
//           "& .MuiOutlinedInput-root": {
//             backgroundColor: "rgba(255, 255, 255, 0.08)",
//             borderRadius: "8px",
//             "& fieldset": {
//               borderColor: "rgba(255, 255, 255, 0.3)",
//               borderWidth: "1px",
//             },
//             "&:hover fieldset": {
//               borderColor: "#00bcd4",
//             },
//             "&.Mui-focused fieldset": {
//               borderColor: "#00bcd4",
//               borderWidth: "2px",
//             },
//           },
//           "& .MuiOutlinedInput-input": {
//             color: "#ffffff",
//           },
//           "& .MuiIconButton-root": {
//             color: "rgba(255, 255, 255, 0.7)",
//           },
//         },
//       },
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "rgba(30, 30, 30, 0.85)",
//           backdropFilter: "blur(5px)",
//           color: "#ffffff",
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
//         },
//         list: {
//           "& .MuiMenuItem-root": {
//             "&:hover": {
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//             "&.Mui-selected": {
//               backgroundColor: "rgba(0, 188, 212, 0.16)",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 188, 212, 0.24)",
//               },
//             },
//           },
//         },
//       },
//     },
//     MuiDialog: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "#1e1e1e",
//           backgroundImage: "none",
//           border: "1px solid rgba(255, 255, 255, 0.2)",
//         },
//       },
//     },
//   },
// });

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [registrationToken, setRegistrationToken] = useState(null);

//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const otpInputRefs = useRef([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({
//         ...prev,
//         phone: value.replace(/\D/g, "").slice(0, 10),
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email))
//       newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10)
//       newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.password || formData.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword)
//       newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});

//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: formData.phone,
//     };

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/register/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(apiPayload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok && result.registration_token) {
//         // --- THIS IS THE ADDED SUCCESS ALERT ---
//         Swal.fire({
//           icon: "success",
//           title: "Registration Successful!",
//           text: "Please check your email for the OTP to verify your account.",
//           timer: 3000,
//           showConfirmButton: false,
//         });
//         // -----------------------------------------

//         setRegistrationToken(result.registration_token);
//         setOtpDialogOpen(true);
//       } else {
//         setErrors(
//           result.errors || {
//             general: result.message || "Registration failed. Please try again.",
//           }
//         );
//       }
//     } catch (error) {
//       setErrors({ general: "An error occurred. Please try again later." });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOtpChange = (element, index) => {
//     if (isNaN(element.value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);

//     if (element.value && index < otp.length - 1) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpInputRefs.current[index - 1].focus();
//     }
//   };

//   const handleClearOtp = () => {
//     setOtp(new Array(6).fill(""));
//     otpInputRefs.current[0].focus();
//   };

//   const handleVerifyOtp = async () => {
//     const otpCode = otp.join("");
//     if (otpCode.length < 6) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please enter the complete 6-digit OTP.",
//       });
//       return;
//     }
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Please try registering again.",
//       });
//       return;
//     }

//     try {
//       const response = await fetch(
//         "https://tdtlworld.com/dss-gatep-backend/api/verify/registration/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             otp: otpCode,
//             registration_token: registrationToken,
//           }),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "OTP Verified! You can now log in.",
//         });
//         setOtpDialogOpen(false);
//         navigate("/gatep/login");
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.error || "Invalid OTP or verification failed.",
//         });
//         handleClearOtp();
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred during verification.",
//       });
//       handleClearOtp();
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     if (!registrationToken) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Registration token not found. Cannot resend OTP.",
//       });
//       setResendLoading(false);
//       return;
//     }
//     try {
//       const response = await fetch("/resend-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ registration_token: registrationToken }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "A new OTP has been sent.",
//         });
//         handleClearOtp();
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: data.error || "Failed to resend OTP.",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "An error occurred while resending OTP.",
//       });
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseOtpDialog = () => {
//     setOtpDialogOpen(false);
//     handleClearOtp();
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           overflow: "hidden",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           padding: 4,
//         }}
//       >
//         <video
//           autoPlay
//           loop
//           muted
//           style={{
//             position: "absolute",
//             width: "100%",
//             left: "50%",
//             top: "50%",
//             height: "100%",
//             objectFit: "cover",
//             transform: "translate(-50%, -50%)",
//             zIndex: -1,
//           }}
//         >
//           <source
//             src={`${process.env.PUBLIC_URL}/assets/register.mp4`}
//             type="video/mp4"
//           />
//           Your browser does not support the video tag.
//         </video>
//         <Paper
//           elevation={24}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             padding: 4,
//             maxWidth: 500,
//             width: "100%",
//             maxHeight: "100vh",
//             overflowY: "auto",
//             zIndex: 1,
//           }}
//         >
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <Typography
//               variant="h5"
//               align="center"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",
//                 fontSize: "1.8rem",
//               }}
//             >
//               Register Here
//             </Typography>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.8)",
//                 mb: 1,
//                 fontSize: "1rem",
//               }}
//             >
//               Create your account
//             </Typography>
//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {errors.general}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               size="small"
//               name="username"
//               label="Username"
//               value={formData.username}
//               onChange={handleChange}
//               error={!!errors.username}
//               helperText={errors.username}
//               autoComplete="off"
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="email"
//               label="Email "
//               type="email"
//               value={formData.email}
//               onChange={handleChange}
//               error={!!errors.email}
//               helperText={errors.email}
//               autoComplete="off"
//             />
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 fullWidth
//                 size="small"
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 autoComplete="off"
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start"></InputAdornment>
//                   ),
//                 }}
//               />
//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 name="role"
//                 label="Role"
//                 value={formData.role}
//                 onChange={handleChange}
//                 error={!!errors.role}
//                 helperText={errors.role}
//               >
//                 {roleOptions.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </Box>
//             <TextField
//               fullWidth
//               size="small"
//               name=" password"
//               label="Create Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               autoComplete="new-password"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               fullWidth
//               size="small"
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               autoComplete="new-password"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((s) => !s)}
//                       edge="end"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 2,
//                 backgroundColor: "#000",
//                 color: "white",
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: "bold",
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "#333" },
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <CircularProgress
//                   size={24}
//                   sx={{ color: "white", position: "absolute" }}
//                 />
//               ) : (
//                 "Sign Up"
//               )}
//             </Button>
//             <Typography
//               variant="body2"
//               align="center"
//               sx={{ color: "rgba(255, 255, 255, 0.8)", mt: 1 }}
//             >
//               Already have an account?{" "}
//               <Link
//                 component={RouterLink}
//                 to="/gatep/login"
//                 sx={{
//                   color: "white",
//                   textDecoration: "underline",
//                   fontWeight: "bold",
//                   "&:hover": { color: "#00bcd4" },
//                 }}
//               >
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>

//       <Dialog
//         open={otpDialogOpen}
//         onClose={handleCloseOtpDialog}
//         PaperProps={{
//           elevation: 24,
//           sx: {
//             maxWidth: "450px",
//             width: "100%",
//             padding: "25px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             borderRadius: "12px",
//             position: "relative",
//           },
//         }}
//       >
//         <IconButton
//           aria-label="close"
//           onClick={handleCloseOtpDialog}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "text.secondary",
//             "&:hover": {
//               color: "text.primary",
//               backgroundColor: "rgba(255, 255, 255, 0.1)",
//             },
//           }}
//         >
//           <CloseIcon fontSize="small" />
//         </IconButton>

//         <Box sx={{ mb: 3, textAlign: "center" }}>
//           <Typography
//             variant="h5"
//             component="h1"
//             sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
//           >
//             Account Verification
//           </Typography>
//           <Typography variant="body1" sx={{ color: "text.secondary" }}>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//         </Box>

//         <Stack
//           direction="row"
//           spacing={1.5}
//           sx={{ mb: 3, justifyContent: "center" }}
//         >
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e.target, index)}
//               onKeyDown={(e) => handleOtpKeyDown(e, index)}
//               inputRef={(el) => (otpInputRefs.current[index] = el)}
//               inputProps={{
//                 maxLength: 1,
//                 style: {
//                   textAlign: "center",
//                   fontSize: "1.5rem",
//                   fontFamily: "'Trebuchet MS', sans-serif",
//                 },
//               }}
//               sx={{
//                 width: { xs: "2.5em", sm: "3em" },
//                 height: { xs: "2.5em", sm: "3em" },
//                 "& .MuiOutlinedInput-root": {
//                   height: "100%",
//                   "&.Mui-focused": {
//                     transform: "scale(1.05)",
//                     transition: "transform 0.2s ease-in-out",
//                   },
//                 },
//                 "& .MuiOutlinedInput-input": {
//                   padding: 0,
//                 },
//               }}
//             />
//           ))}
//         </Stack>

//         <Stack direction="column" spacing={2} sx={{ width: "85%" }}>
//           <Button
//             variant="contained"
//             onClick={handleVerifyOtp}
//             size="large"
//             sx={{
//               borderRadius: "8px",
//               fontWeight: 700,
//               textTransform: "none",
//             }}
//           >
//             Verify
//           </Button>
//           <Stack direction="row" spacing={1} justifyContent="center">
//             <Button
//               onClick={handleResendOtp}
//               disabled={resendLoading}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               {resendLoading ? "Sending..." : "Resend OTP"}
//             </Button>
//             <Typography sx={{ color: "text.secondary" }}>|</Typography>
//             <Button
//               onClick={handleClearOtp}
//               sx={{
//                 color: "text.secondary",
//                 textTransform: "none",
//                 "&:hover": {
//                   color: "primary.main",
//                   backgroundColor: "transparent",
//                 },
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Stack>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;




// import { useState, useRef } from "react";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Paper,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { Visibility, VisibilityOff, Close as CloseIcon } from "@mui/icons-material";
// import Swal from "sweetalert2";

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#00D4FF" },
//     secondary: { main: "#7BD3FF" },
//     background: { default: "#06090f", paper: "rgba(12,18,28,0.55)" },
//     text: { primary: "#E6F7FF", secondary: "rgba(230,247,255,0.75)" },
//   },
//   shape: { borderRadius: 16 },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           backgroundImage:
//             "linear-gradient(135deg, rgba(12,18,28,0.65) 0%, rgba(16,24,36,0.55) 50%, rgba(12,18,28,0.65) 100%)",
//           border: "1px solid rgba(0,212,255,0.25)",
//           boxShadow:
//             "0 10px 25px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.05)",
//           backdropFilter: "blur(14px)",
//         },
//       },
//     },
//     MuiTextField: {
//       defaultProps: { size: "small", fullWidth: true },
//       styleOverrides: {
//         root: {
//           "--ring": "rgba(0,212,255,0.45)",
//           "--field": "rgba(255,255,255,0.06)",
//           "& .MuiInputLabel-root": { color: "rgba(230,247,255,0.65)" },
//           "& .MuiInputLabel-root.Mui-focused": { color: "#7BD3FF" },
//           "& .MuiOutlinedInput-root": {
//             backgroundColor: "var(--field)",
//             borderRadius: 12,
//             transition: "border-color .2s, background-color .2s, box-shadow .2s",
//             "& fieldset": { borderColor: "rgba(255,255,255,0.15)" },
//             "&:hover fieldset": { borderColor: "rgba(0,212,255,0.5)" },
//             "&.Mui-focused fieldset": { borderColor: "#00D4FF" },
//             "&.Mui-focused": { boxShadow: "0 0 0 4px var(--ring)" },
//           },
//           "& .MuiOutlinedInput-input": { color: "#E6F7FF" },
//           "& .MuiIconButton-root": { color: "rgba(230,247,255,0.8)" },
//         },
//       },
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: "rgba(12,18,28,0.9)",
//           backdropFilter: "blur(10px)",
//           border: "1px solid rgba(0,212,255,0.25)",
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: { root: { borderRadius: 12, textTransform: "none", fontWeight: 700 } },
//     },
//     MuiDialog: {
//       styleOverrides: {
//         paper: {
//           backgroundImage:
//             "linear-gradient(135deg, rgba(12,18,28,0.78) 0%, rgba(16,24,36,0.7) 100%)",
//           border: "1px solid rgba(0,212,255,0.25)",
//           backdropFilter: "blur(16px)",
//         },
//       },
//     },
//   },
// });

// const BackgroundVideo = ({ src, poster }) => (
//   <>
//     <video
//       autoPlay
//       loop
//       muted
//       playsInline
//       poster={poster}
//       style={{
//         position: "absolute",
//         inset: 0,
//         width: "100%",
//         height: "100%",
//         objectFit: "cover",
//         zIndex: -2,
//       }}
//     >
//       <source src={src} type="video/mp4" />
//     </video>
//     <div
//       style={{
//         position: "absolute",
//         inset: 0,
//         zIndex: -1,
//         background:
//           "radial-gradient(1000px 600px at 70% 20%, rgba(0,212,255,0.18), transparent 60%), radial-gradient(800px 500px at 30% 80%, rgba(123,211,255,0.14), transparent 50%)",
//         pointerEvents: "none",
//       }}
//     />
//   </>
// );

// const roleOptions = ["TALENT", "EMPLOYER"];

// const Register = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     role: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpDialogOpen, setOtpDialogOpen] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [registrationToken, setRegistrationToken] = useState(null);
//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const otpInputRefs = useRef([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       setFormData((prev) => ({ ...prev, phone: value.replace(/\D/g, "").slice(0, 10) }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "Username is required";
//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Email is invalid";
//     if (!formData.phone.trim() || formData.phone.length !== 10) newErrors.phone = "Phone number must be 10 digits";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.password || formData.password.length < 6) newErrors.password = "Password must be at least 6 characters";
//     if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Passwords do not match";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }
//     setIsLoading(true);
//     setErrors({});
//     const apiPayload = {
//       username: formData.username,
//       email: formData.email,
//       password: formData.password,
//       confirm_password: formData.confirmPassword,
//       user_role: formData.role,
//       phone_number: formData.phone,
//     };
//     try {
//       const response = await fetch("https://tdtlworld.com/dss-gatep-backend/api/register/", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(apiPayload),
//       });
//       const result = await response.json();
//       if (response.ok && result.registration_token) {
//         Swal.fire({
//           icon: "success",
//           title: "Registration Successful",
//           text: "Please check your email for the OTP to verify your account.",
//           timer: 2800,
//           showConfirmButton: false,
//           background: "#0b121c",
//           color: "#E6F7FF",
//         });
//         setRegistrationToken(result.registration_token);
//         setOtpDialogOpen(true);
//       } else {
//         setErrors(result.errors || { general: result.message || "Registration failed. Please try again." });
//       }
//     } catch {
//       setErrors({ general: "An error occurred. Please try again later." });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOtpChange = (element, index) => {
//     if (isNaN(element.value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);
//     if (element.value && index < otp.length - 1) otpInputRefs.current[index + 1].focus();
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) otpInputRefs.current[index - 1].focus();
//   };

//   const handleClearOtp = () => {
//     setOtp(new Array(6).fill(""));
//     otpInputRefs.current[0].focus();
//   };

//   const handleVerifyOtp = async () => {
//     const otpCode = otp.join("");
//     if (otpCode.length < 6) {
//       Swal.fire({ icon: "error", title: "Enter complete 6-digit OTP", background: "#0b121c", color: "#E6F7FF" });
//       return;
//     }
//     if (!registrationToken) {
//       Swal.fire({ icon: "error", title: "Registration token not found", background: "#0b121c", color: "#E6F7FF" });
//       return;
//     }
//     try {
//       const response = await fetch("https://tdtlworld.com/dss-gatep-backend/api/verify/registration/", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ otp: otpCode, registration_token: registrationToken }),
//       });
//       const result = await response.json();
//       if (response.ok) {
//         Swal.fire({ icon: "success", title: "OTP Verified", text: "You can now log in.", background: "#0b121c", color: "#E6F7FF" });
//         setOtpDialogOpen(false);
//         navigate("/gatep/login");
//       } else {
//         Swal.fire({ icon: "error", title: result.error || "Invalid OTP", background: "#0b121c", color: "#E6F7FF" });
//         handleClearOtp();
//       }
//     } catch {
//       Swal.fire({ icon: "error", title: "Verification error", background: "#0b121c", color: "#E6F7FF" });
//       handleClearOtp();
//     }
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     if (!registrationToken) {
//       Swal.fire({ icon: "error", title: "Registration token not found", background: "#0b121c", color: "#E6F7FF" });
//       setResendLoading(false);
//       return;
//     }
//     try {
//       const response = await fetch("/resend-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ registration_token: registrationToken }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({ icon: "success", title: "A new OTP has been sent", background: "#0b121c", color: "#E6F7FF" });
//         handleClearOtp();
//       } else {
//         Swal.fire({ icon: "error", title: data.error || "Failed to resend OTP", background: "#0b121c", color: "#E6F7FF" });
//       }
//     } catch {
//       Swal.fire({ icon: "error", title: "Error while resending OTP", background: "#0b121c", color: "#E6F7FF" });
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseOtpDialog = () => {
//     setOtpDialogOpen(false);
//     handleClearOtp();
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           height: "100vh",
//           position: "relative",
//           overflow: "hidden",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           p: 4,
//         }}
//       >
//         <BackgroundVideo
//             src={`${process.env.PUBLIC_URL}/assets/register.mp4`}
//                         type="video/mp4"

//         />

//         <Paper
//           elevation={24}
//           sx={{
//             maxWidth: 520,
//             width: "100%",
//             maxHeight: "100vh",
//             overflowY: "auto",
//             p: { xs: 3, sm: 4 },
//             position: "relative",
//           }}
//         >
//           <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//             <Typography
//               variant="h4"
//               align="center"
//               sx={{
//                 fontWeight: 800,
//                 letterSpacing: 0.4,
//                 background:
//                   "linear-gradient(90deg, #E6F7FF 0%, #9EE6FF 40%, #00D4FF 60%, #E6F7FF 100%)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//               }}
//             >
//               Register Here
//             </Typography>
//             <Typography variant="body2" align="center" sx={{ color: "text.secondary", mb: 1 }}>
//               Create your account
//             </Typography>

//             {errors.general && (
//               <Typography color="error" align="center" sx={{ mb: 1 }}>
//                 {errors.general}
//               </Typography>
//             )}

//             <TextField name="username" label="Username" value={formData.username} onChange={handleChange} error={!!errors.username} helperText={errors.username} />
//             <TextField name="email" label="Email" type="email" value={formData.email} onChange={handleChange} error={!!errors.email} helperText={errors.email} />

//             <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
//               <TextField
//                 name="phone"
//                 label="Phone Number"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 error={!!errors.phone}
//                 helperText={errors.phone}
//                 InputProps={{ startAdornment: <InputAdornment position="start">+91</InputAdornment> }}
//               />
//               <TextField select name="role" label="Role" value={formData.role} onChange={handleChange} error={!!errors.role} helperText={errors.role}>
//                 {roleOptions.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </Box>

//             <TextField
//               name="password"
//               label="Create Password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               autoComplete="new-password"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPassword((s) => !s)} edge="end">
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               name="confirmPassword"
//               label="Confirm Password"
//               type={showConfirmPassword ? "text" : "password"}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               error={!!errors.confirmPassword}
//               helperText={errors.confirmPassword}
//               autoComplete="new-password"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowConfirmPassword((s) => !s)} edge="end">
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <Button
//               type="submit"
//               variant="contained"
//               disabled={isLoading}
//               sx={{
//                 mt: 1,
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 background:
//                   "linear-gradient(90deg, #00B8E6 0%, #00D4FF 50%, #7BD3FF 100%)",
//                 boxShadow: "0 10px 25px rgba(0,212,255,0.35)",
//                 "&:hover": {
//                   transform: "translateY(-1px)",
//                   boxShadow: "0 14px 32px rgba(0,212,255,0.45)",
//                 },
//               }}
//             >
//               {isLoading ? <CircularProgress size={24} sx={{ color: "#001018" }} /> : "Sign Up"}
//             </Button>

//             <Typography variant="body2" align="center" sx={{ color: "text.secondary", mt: 1 }}>
//               Already have an account?{" "}
//               <Link component={RouterLink} to="/gatep/login" sx={{ color: "primary.main", fontWeight: 700 }}>
//                 Login
//               </Link>
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>

//       <Dialog
//         open={otpDialogOpen}
//         onClose={handleCloseOtpDialog}
//         PaperProps={{
//           elevation: 24,
//           sx: {
//             maxWidth: 480,
//             width: "100%",
//             p: 3,
//             borderRadius: 14,
//             position: "relative",
//           },
//         }}
//       >
//         <IconButton
//           aria-label="close"
//           onClick={handleCloseOtpDialog}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "text.secondary",
//             "&:hover": { color: "primary.main", backgroundColor: "rgba(0,212,255,0.08)" },
//           }}
//         >
//           <CloseIcon fontSize="small" />
//         </IconButton>

//         <Box sx={{ mb: 3, textAlign: "center" }}>
//           <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5, color: "text.primary" }}>
//             Account Verification
//           </Typography>
//           <Typography variant="body1" sx={{ color: "text.secondary" }}>
//             An OTP has been sent to your email. Please enter it below.
//           </Typography>
//         </Box>

//         <Stack direction="row" spacing={1.25} sx={{ mb: 3, justifyContent: "center" }}>
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e.target, index)}
//               onKeyDown={(e) => handleOtpKeyDown(e, index)}
//               inputRef={(el) => (otpInputRefs.current[index] = el)}
//               inputProps={{
//                 maxLength: 1,
//                 style: { textAlign: "center", fontSize: "1.4rem", width: "2.6em" },
//               }}
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   height: "2.8em",
//                   "&.Mui-focused": { transform: "scale(1.05)" },
//                 },
//                 "& .MuiOutlinedInput-input": { padding: 0 },
//               }}
//             />
//           ))}
//         </Stack>

//         <Stack direction="column" spacing={2} sx={{ width: "85%", mx: "auto" }}>
//           <Button
//             variant="contained"
//             onClick={handleVerifyOtp}
//             size="large"
//             sx={{
//               background:
//                 "linear-gradient(90deg, #00B8E6 0%, #00D4FF 50%, #7BD3FF 100%)",
//             }}
//           >
//             Verify
//           </Button>
//           <Stack direction="row" spacing={1} justifyContent="center">
//             <Button
//               onClick={handleResendOtp}
//               disabled={resendLoading}
//               sx={{
//                 color: "text.secondary",
//                 "&:hover": { color: "primary.main", backgroundColor: "transparent" },
//               }}
//             >
//               {resendLoading ? "Sending..." : "Resend OTP"}
//             </Button>
//             <Typography sx={{ color: "text.secondary" }}>|</Typography>
//             <Button
//               onClick={handleClearOtp}
//               sx={{
//                 color: "text.secondary",
//                 "&:hover": { color: "primary.main", backgroundColor: "transparent" },
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Stack>
//       </Dialog>
//     </ThemeProvider>
//   );
// };

// export default Register;




import { useState, useRef } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  Paper,
  Link,
  InputAdornment,
  IconButton,
  CircularProgress,
  Dialog,
  Stack,
  DialogContent,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Visibility,
  VisibilityOff,
  Close as CloseIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
} from "@mui/icons-material";
import Swal from "sweetalert2";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#00D4FF" },
    secondary: { main: "#7BD3FF" },
    background: { default: "#06090f", paper: "rgba(12,18,28,0.55)" },
    text: { primary: "#E6F7FF", secondary: "rgba(230,247,255,0.75)" },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage:
            "linear-gradient(135deg, rgba(12,18,28,0.65) 0%, rgba(16,24,36,0.55) 50%, rgba(12,18,28,0.65) 100%)",
          border: "1px solid rgba(0,212,255,0.25)",
          boxShadow:
            "0 10px 25px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.05)",
          backdropFilter: "blur(14px)",
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small", fullWidth: true },
      styleOverrides: {
        root: {
          "--ring": "rgba(0,212,255,0.45)",
          "--field": "rgba(255,255,255,0.06)",
          "& .MuiInputLabel-root": { color: "rgba(230,247,255,0.65)" },
          "& .MuiInputLabel-root.Mui-focused": { color: "#7BD3FF" },
          "& .MuiOutlinedInput-root": {
            backgroundColor: "var(--field)",
            borderRadius: 12,
            transition: "border-color .2s, background-color .2s, box-shadow .2s",
            "& fieldset": { borderColor: "rgba(255,255,255,0.15)" },
            "&:hover fieldset": { borderColor: "rgba(0,212,255,0.5)" },
            "&.Mui-focused fieldset": { borderColor: "#00D4FF" },
            "&.Mui-focused": { boxShadow: "0 0 0 4px var(--ring)" },
          },
          "& .MuiOutlinedInput-input": { color: "#E6F7FF" },
          "& .MuiIconButton-root": { color: "rgba(230,247,255,0.8)" },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: "rgba(12,18,28,0.9)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(0,212,255,0.25)",
        },
      },
    },
    MuiButton: {
      styleOverrides: { root: { borderRadius: 12, textTransform: "none", fontWeight: 700 } },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage:
            "linear-gradient(135deg, rgba(12,18,28,0.78) 0%, rgba(16,24,36,0.7) 100%)",
          border: "1px solid rgba(0,212,255,0.25)",
          backdropFilter: "blur(16px)",
        },
      },
    },
  },
});

const BackgroundVideo = ({ src, poster }) => (
  <>
    <video
      autoPlay
      loop
      muted
      playsInline
      poster={poster}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        zIndex: -2,
      }}
    >
      <source src={src} type="video/mp4" />
    </video>
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: -1,
        background:
          "radial-gradient(1000px 600px at 70% 20%, rgba(0,212,255,0.18), transparent 60%), radial-gradient(800px 500px at 30% 80%, rgba(123,211,255,0.14), transparent 50%)",
        pointerEvents: "none",
      }}
    />
  </>
);

const roleOptions = ["TALENT", "EMPLOYER"];

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    role: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [registrationToken, setRegistrationToken] = useState(null);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const otpInputRefs = useRef([]);
  const [registrationSuccessOpen, setRegistrationSuccessOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      setFormData((prev) => ({ ...prev, phone: value.replace(/\D/g, "").slice(0, 10) }));
    } else if (name === "password" || name === "confirmPassword") {
      setFormData((prev) => ({ ...prev, [name]: value.replace(/\s/g, "") }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // --- UPDATED: Enhanced password validation logic ---
  const validateForm = () => {
    const newErrors = {};
    if (!formData.username.trim()) newErrors.username = "Username is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Email is invalid";
    if (!formData.phone.trim() || formData.phone.length !== 10) newErrors.phone = "Phone number must be 10 digits";
    if (!formData.role) newErrors.role = "Role is required";

    // Password validation checks
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (
      formData.password.length < 6 ||
      !/[A-Z]/.test(formData.password) || // Must contain one uppercase letter
      !/\d/.test(formData.password) // Must contain one number
    ) {
      newErrors.password = "Use 6+ characters with an uppercase letter & a number.";
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setIsLoading(true);
    setErrors({});
    const apiPayload = {
      username: formData.username,
      email: formData.email,
      password: formData.password,
      confirm_password: formData.confirmPassword,
      user_role: formData.role,
      phone_number: formData.phone,
    };
    try {
      const response = await fetch("https://tdtlworld.com/dss-gatep-backend/api/register/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apiPayload),
      });
      const result = await response.json();
      if (response.ok && result.registration_token) {
        setRegistrationToken(result.registration_token);
        setOtpDialogOpen(true);
      } else {
        setErrors(result.errors || { general: result.message || "Registration failed. Please try again." });
      }
    } catch {
      setErrors({ general: "An error occurred. Please try again later." });
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpChange = (element, index) => {
    if (isNaN(element.value)) return;
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);
    if (element.value && index < otp.length - 1) otpInputRefs.current[index + 1].focus();
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) otpInputRefs.current[index - 1].focus();
  };

  const handleClearOtp = () => {
    setOtp(new Array(6).fill(""));
    otpInputRefs.current[0].focus();
  };

  const handleVerifyOtp = async () => {
    const otpCode = otp.join("");
    if (otpCode.length < 6) {
      Swal.fire({ icon: "error", title: "Enter complete 6-digit OTP", background: "#0b121c", color: "#E6F7FF" });
      return;
    }
    if (!registrationToken) {
      Swal.fire({ icon: "error", title: "Registration token not found", background: "#0b121c", color: "#E6F7FF" });
      return;
    }
    try {
      const response = await fetch("https://tdtlworld.com/dss-gatep-backend/api/verify/registration/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otp: otpCode, registration_token: registrationToken }),
      });
      const result = await response.json();
      if (response.ok) {
        setOtpDialogOpen(false);
        setRegistrationSuccessOpen(true);
        setTimeout(() => {
          setRegistrationSuccessOpen(false);
          navigate("/db-shiksha/gatep/login");
        }, 2000);
      } else {
        Swal.fire({ icon: "error", title: result.error || "Invalid OTP", background: "#0b121c", color: "#E6F7FF" });
        handleClearOtp();
      }
    } catch {
      Swal.fire({ icon: "error", title: "Verification error", background: "#0b121c", color: "#E6F7FF" });
      handleClearOtp();
    }
  };

  const handleResendOtp = async () => {
    setResendLoading(true);
    if (!registrationToken) {
      Swal.fire({ icon: "error", title: "Registration token not found", background: "#0b121c", color: "#E6F7FF" });
      setResendLoading(false);
      return;
    }
    try {
      const response = await fetch("/resend-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ registration_token: registrationToken }),
      });
      const data = await response.json();
      if (response.ok) {
        Swal.fire({ icon: "success", title: "A new OTP has been sent", background: "#0b121c", color: "#E6F7FF" });
        handleClearOtp();
      } else {
        Swal.fire({ icon: "error", title: data.error || "Failed to resend OTP", background: "#0b121c", color: "#E6F7FF" });
      }
    } catch {
      Swal.fire({ icon: "error", title: "Error while resending OTP", background: "#0b121c", color: "#E6F7FF" });
    } finally {
      setResendLoading(false);
    }
  };

  const handleCloseOtpDialog = () => {
    setOtpDialogOpen(false);
    handleClearOtp();
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={registrationSuccessOpen}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            minWidth: "350px",
            bgcolor: "background.paper",
            backgroundImage: "none",
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.5)",
          },
        }}
      >
        <DialogContent
          sx={{
            pt: 4,
            pb: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 50, color: "success.main" }} />
          <Typography
            variant="h5"
            component="div"
            sx={{
              fontWeight: "bold",
              fontSize: "1.25rem",
              textAlign: "center",
              color: "text.primary",
            }}
          >
            Registration Successful!
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", textAlign: "center" }}
          >
            Your account has been verified. You can now log in.
          </Typography>
        </DialogContent>
      </Dialog>

      <Box
        sx={{
          height: "100vh",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 4,
        }}
      >
        <BackgroundVideo
          src={`${process.env.PUBLIC_URL}/assets/register.mp4`}
          type="video/mp4"
        />

        <Paper
          elevation={24}
          sx={{
            maxWidth: 520,
            width: "100%",
            maxHeight: "100vh",
            overflowY: "auto",
            p: { xs: 3, sm: 4 },
            position: "relative",
          }}
        >
          <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography
              variant="h4"
              align="center"
              sx={{
                fontWeight: 800,
                letterSpacing: 0.4,
                background:
                  "linear-gradient(90deg, #E6F7FF 0%, #9EE6FF 40%, #00D4FF 60%, #E6F7FF 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Register Here
            </Typography>
            <Typography variant="body2" align="center" sx={{ color: "text.secondary", mb: 1 }}>
              Create your account
            </Typography>

            {errors.general && (
              <Typography color="error" align="center" sx={{ mb: 1 }}>
                {errors.general}
              </Typography>
            )}

            <TextField name="username" label="Username" value={formData.username} onChange={handleChange} error={!!errors.username} helperText={errors.username} />
            <TextField name="email" label="Email" type="email" value={formData.email} onChange={handleChange} error={!!errors.email} helperText={errors.email} />

            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
              <TextField
                name="phone"
                label="Phone Number"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                error={!!errors.phone}
                helperText={errors.phone}
                InputProps={{ startAdornment: <InputAdornment position="start">+91</InputAdornment> }}
              />
              <TextField select name="role" label="Role" value={formData.role} onChange={handleChange} error={!!errors.role} helperText={errors.role}>
                {roleOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <TextField
              name="password"
              label="Create Password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
              error={!!errors.password}
              helperText={errors.password}
              autoComplete="new-password"
              onPaste={(e) => {
                e.preventDefault();
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword((s) => !s)} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              name="confirmPassword"
              label="Confirm Password"
              type={showConfirmPassword ? "text" : "password"}
              value={formData.confirmPassword}
              onChange={handleChange}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword}
              autoComplete="new-password"
              onPaste={(e) => {
                e.preventDefault();
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirmPassword((s) => !s)} edge="end">
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              variant="contained"
              disabled={isLoading}
              sx={{
                mt: 1,
                py: 1.2,
                fontSize: "0.95rem",
                background:
                  "linear-gradient(90deg, #00B8E6 0%, #00D4FF 50%, #7BD3FF 100%)",
                boxShadow: "0 10px 25px rgba(0,212,255,0.35)",
                "&:hover": {
                  transform: "translateY(-1px)",
                  boxShadow: "0 14px 32px rgba(0,212,255,0.45)",
                },
              }}
            >
              {isLoading ? <CircularProgress size={24} sx={{ color: "#001018" }} /> : "Sign Up"}
            </Button>

            <Typography variant="body2" align="center" sx={{ color: "text.secondary", mt: 1 }}>
              Already have an account?{" "}
              <Link component={RouterLink} to="/db-shiksha/gatep/login" sx={{ color: "primary.main", fontWeight: 700 }}>
                Login
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Box>

      <Dialog
        open={otpDialogOpen}
        onClose={handleCloseOtpDialog}
        PaperProps={{
          elevation: 24,
          sx: {
            maxWidth: 480,
            width: "100%",
            p: 3,
            borderRadius: 14,
            position: "relative",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseOtpDialog}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            color: "text.secondary",
            "&:hover": { color: "primary.main", backgroundColor: "rgba(0,212,255,0.08)" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Box sx={{ mb: 3, textAlign: "center" }}>
          <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5, color: "text.primary" }}>
            Account Verification
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            An OTP has been sent to your email. Please enter it below.
          </Typography>
        </Box>

        <Stack direction="row" spacing={1.25} sx={{ mb: 3, justifyContent: "center" }}>
          {otp.map((digit, index) => (
            <TextField
              key={index}
              value={digit}
              onChange={(e) => handleOtpChange(e.target, index)}
              onKeyDown={(e) => handleOtpKeyDown(e, index)}
              inputRef={(el) => (otpInputRefs.current[index] = el)}
              inputProps={{
                maxLength: 1,
                style: { textAlign: "center", fontSize: "1.4rem", width: "2.6em" },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "2.8em",
                  "&.Mui-focused": { transform: "scale(1.05)" },
                },
                "& .MuiOutlinedInput-input": { padding: 0 },
              }}
            />
          ))}
        </Stack>

        <Stack direction="column" spacing={2} sx={{ width: "85%", mx: "auto" }}>
          <Button
            variant="contained"
            onClick={handleVerifyOtp}
            size="large"
            sx={{
              background:
                "linear-gradient(90deg, #00B8E6 0%, #00D4FF 50%, #7BD3FF 100%)",
            }}
          >
            Verify
          </Button>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              onClick={handleResendOtp}
              disabled={resendLoading}
              sx={{
                color: "text.secondary",
                "&:hover": { color: "primary.main", backgroundColor: "transparent" },
              }}
            >
              {resendLoading ? "Sending..." : "Resend OTP"}
            </Button>
            <Typography sx={{ color: "text.secondary" }}>|</Typography>
            <Button
              onClick={handleClearOtp}
              sx={{
                color: "text.secondary",
                "&:hover": { color: "primary.main", backgroundColor: "transparent" },
              }}
            >
              Clear
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </ThemeProvider>
  );
};

export default Register;